<template>
    <div>
        <div v-if="userPermissions.canAddTeamMembers">

            <a name="invite" id="invite" class="mt-44"></a>

            <!-- Add Team Member -->
            <jet-form-section @submitted="addTeamMember" class="mt-12">
                <template #title>

                    Add Team Member
                </template>

                <template #description>
                    Add a new team member to your team, allowing them to collaborate with you.
                </template>


                <template v-if="can_invite_outside_sso" #form>

                    <div class="col-span-6" v-if="domains.length > 0">
                        <div class="max-w-xl text-sm font-medium text-gray-600">
                            Invite with link (anyone with a @{{
                                domains.join(' or @') }}
                            email address)
                        </div>
                    </div>
                    <div class="col-span-6 -mt-5 sm:col-span-4 flex flex-col mb-2" v-if="domains.length > 0">
                        <div class="col-span-6 sm:col-span-4">
                            <div class="flex w-full">
                                <div class="-mr-px flex flex-grow">
                                    <input type="text" name="invite-link" id="invite-link"
                                        class="col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-2 pr-3 text-basesm:pl-9 sm:text-sm/6 border-gray-300 text-gray-400"
                                        :disabled="true" :value="team_invite_link" />
                                </div>
                                <button type="button"
                                    class="flex shrink-0 justify-center items-center rounded-r-md bg-gray-100 hover:bg-gray-200 border border-gray-300 px-3 text-gray-600 text-sm gap-x-2"
                                    v-tippy="{ content: 'copy in your clipboard' }" v-clipboard:copy="team_invite_link"
                                    v-clipboard:success="copied">
                                    <ClipboardIcon class="w-4 h-4 text-gray-400" aria-hidden="true" /> Copy
                                </button>
                            </div>
                        </div>

                    </div>


                    <div class="col-span-6">
                        <div class="max-w-xl text-sm font-medium text-gray-600 ">
                            Invite with email
                        </div>
                    </div>

                    <div v-for="(invite, index) in addTeamMemberForm.invites" :class="[index > 0 ? '' : '-mt-5',
                        'col-span-6 sm:col-span-4 flex flex-col']">
                        <div class="col-span-6 sm:col-span-4">
                            <div class="flex w-full">
                                <div class="-mr-px flex flex-grow">
                                    <input type="email" name="email" id="email"
                                        class="col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-2 pr-3 text-basesm:pl-9 sm:text-sm/6 border-gray-300 text-gray-600 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                        v-model="invite.email" placeholder="john@doe.com"
                                        @update:modelValue="changeEmailValue($event, index)" />
                                </div>
                                <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                    <select id="role" name="role" aria-label="Role"
                                        class="col-start-1 row-start-1 w-full appearance-none rounded-r-md py-1.5 pl-3 pr-7 text-base text-gray-600 placeholder:text-gray-400 sm:text-sm/6 border bg-gray-100 hover:bg-gray-200 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 cursor-pointer"
                                        v-model="invite.role">
                                        <option v-for="role in the_roles" :key="role.key" :value="role.key">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <ChevronDownIcon
                                        class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                        aria-hidden="true" />
                                </div>
                            </div>
                            <jet-input-error :message="invite.error" class="mt-2" />

                        </div>

                    </div>

                    <div class="col-span-6">
                        <a href="#"
                            class="max-w-xl text-sm text-gray-600 hover:text-gray-700 inline-flex items-center pl-1"
                            @click.prevent.stop="addInvite">
                            <PlusIcon class="w-4 h-4 mr-1" /> Add another
                        </a>
                    </div>

                    <div class="col-span-6 flex flex-col">
                        <div v-for="role in the_roles"
                            class="mt-2 flex w-full justify-start text-xs text-gray-500 text-right"
                            v-html="role.description"></div>
                    </div>

                    <div v-if="false" class="col-span-6 -mt-5 sm:col-span-4 flex flex-col">
                        <div class="col-span-6 sm:col-span-4">
                            <div class="flex w-full">
                                <div class="-mr-px flex flex-grow">
                                    <input type="email" name="email" id="email"
                                        class="col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-2 pr-3 text-basesm:pl-9 sm:text-sm/6 border-gray-300 text-gray-600 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                        v-model="addTeamMemberForm.email" placeholder="john@doe.com" />
                                </div>
                                <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                    <select id="role" name="role" aria-label="Role"
                                        class="col-start-1 row-start-1 w-full appearance-none rounded-r-md py-1.5 pl-3 pr-7 text-base text-gray-600 placeholder:text-gray-400 sm:text-sm/6 border bg-gray-100 hover:bg-gray-200 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 cursor-pointer"
                                        v-model="addTeamMemberForm.role">
                                        <option v-for="role in the_roles" :key="role.key" :value="role.key">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <ChevronDownIcon
                                        class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                        aria-hidden="true" />
                                </div>
                            </div>
                            <jet-input-error :message="addTeamMemberForm.errors.email" class="mt-2" />
                            <div class="mt-2 flex w-full justify-end text-xs text-gray-500 text-right"
                                v-html="role_description"></div>
                        </div>

                    </div>








                    <!-- Member Email -->
                    <!-- <div class="col-span-6 sm:col-span-4 -mt-5">
                        <jet-label for="email" value="Email" />
                        <jet-input id="email" type="email" class="mt-1 block w-full"
                            v-model="addTeamMemberForm.email" />
                        <jet-input-error :message="addTeamMemberForm.errors.email" class="mt-2" />
                    </div> -->

                    <!-- Role -->
                    <!-- <div class="col-span-6 lg:col-span-4" v-if="availableRoles.length > 0">
                        <jet-label for="roles" value="Role" />
                        <jet-input-error :message="addTeamMemberForm.errors.role" class="mt-2" />

                        <div class="relative z-0 mt-1 border border-gray-200 rounded-lg cursor-pointer">
                            <button type="button"
                                class="relative px-4 py-3 inline-flex w-full rounded-lg focus:z-10 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200"
                                :class="{ 'border-t border-gray-200 rounded-t-none': i > 0, 'rounded-b-none': i != Object.keys(availableRoles).length - 1 }"
                                @click="addTeamMemberForm.role = role.key" v-for="(role, i) in availableRoles"
                                :key="role.key">
                                <div
                                    :class="{ 'opacity-50': addTeamMemberForm.role && addTeamMemberForm.role != role.key }">

                                    <div class="flex items-center">
                                        <div class="text-sm text-gray-600"
                                            :class="{ 'font-semibold': addTeamMemberForm.role == role.key }">
                                            {{ role.name }}
                                        </div>

                                        <svg v-if="addTeamMemberForm.role == role.key"
                                            class="ml-2 h-5 w-5 text-green-400" fill="none" stroke-linecap="round"
                                            stroke-linejoin="round" stroke-width="2" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                    </div>

                                    <div class="mt-2 text-xs text-left text-gray-600">
                                        {{ role.description }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div> -->

                </template>

                <template v-else #form>
                    <div class="col-span-6 text-gray-500">
                        Teammates can only be invited through your SSO provider. To invite users from Birdie too, enable
                        <span class="italic">"Allow team members outside the SSO domain to sign in"</span> in Birdie <a
                            :href="route('settings.security')" class="text-blue-500 underline">Security
                            settings</a>.
                    </div>
                </template>

                <template v-if="can_invite_outside_sso" #actions>
                    <!-- <jet-action-message :on="addTeamMemberForm.recentlySuccessful" class="mr-3">
                        Invite sent!
                    </jet-action-message> -->

                    <jet-button :class="{ 'opacity-25': sending_invites }" :disabled="sending_invites"
                        @click="sendInvites"
                        v-html="sending_invites ? 'Sending...' : addTeamMemberForm.invites.length > 1 ? 'Send Invites' : 'Send Invite'">

                    </jet-button>
                </template>
            </jet-form-section>
        </div>

        <div v-if="live_teamInvitations.length > 0 && userPermissions.canAddTeamMembers && can_invite_outside_sso">


            <!-- Team Member Invitations -->
            <jet-action-section class="mt-12">
                <template #title>
                    Pending Team Invitations
                </template>

                <template #description>
                    These people have been invited to your team and have been sent an invitation email. They may join
                    the team by accepting the email invitation.
                </template>

                <!-- Pending Team Member Invitation List -->
                <template #content>
                    <div class="space-y-6 text-sm">
                        <div class="flex items-center justify-between" v-for="invitation in live_teamInvitations"
                            :key="invitation.id">
                            <div class="text-gray-600">{{ invitation.email }}</div>

                            <div class="flex items-center">
                                <!-- Cancel Team Invitation -->
                                <button v-if="!invitation.resent && userPermissions.canRemoveTeamMembers"
                                    class="cursor-pointer ml-6 text-sm text-gray-400 focus:outline-none"
                                    @click="resendTeamInvitation(invitation)">
                                    Resend
                                </button>
                                <button v-else class="cursor-default ml-6 text-sm text-gray-400 focus:outline-none"
                                    v-if="userPermissions.canRemoveTeamMembers">
                                    Sent!
                                </button>

                                <button class="cursor-pointer ml-6 text-sm text-red-500 focus:outline-none"
                                    @click="cancelTeamInvitation(invitation)"
                                    v-if="userPermissions.canRemoveTeamMembers">
                                    Cancel
                                </button>

                            </div>
                        </div>
                    </div>
                </template>
            </jet-action-section>
        </div>


        <a name="team-members" id="team-members"></a>

        <div v-if="team_filtered.length > 0" key="team-members">


            <!-- Manage Team Members -->
            <jet-action-section class="mt-12">
                <template #title>
                    Team Members
                </template>

                <template #description>
                    All of the people that are part of this team.



                </template>

                <!-- Team Member List -->
                <template #content>
                    <div class="space-y-6 divide-y text-sm">

                        <div class="grid grid-cols-8">
                            <div class="col-span-5">
                                <div class="pr-0 lg:pr-2">
                                    <input type="text" v-model="search" placeholder="search…"
                                        class="text-left w-full inline py-2 px-3 border border-gray-300 focus:ring-0 focus:border-blue-500 bg-white focus:bg-white text-birdie-blue focus:text-blue-600 rounded-lg" />
                                </div>
                            </div>

                            <div class="col-span-3 text-right">Role</div>
                        </div>

                        <div class="grid grid-cols-8 pt-5" v-for="user in team_paginated" :key="user.id">

                            <div class="col-span-5 flex items-center">
                                <ProfileImage :user="user" />

                                <div class="ml-4 flex flex-col">
                                    <span>{{ user.name }}</span>
                                    <span class="text-xs text-gray-600">{{ user.email }}</span>
                                </div>
                            </div>



                            <div class="col-span-3 flex items-center justify-end">
                                <!-- Manage Team Member Role -->
                                <button class="ml-2 text-sm text-gray-400 underline" @click="manageRole(user)"
                                    v-if="userPermissions.canAddTeamMembers && availableRoles.length">
                                    {{ displayableRole(user.membership.role) }}
                                </button>

                                <div class="ml-2 text-sm text-gray-400" v-else-if="availableRoles.length">
                                    {{ displayableRole(user.membership.role) }}
                                </div>

                                <!-- Leave Team -->
                                <button class="cursor-pointer ml-6 text-sm text-red-500" @click="confirmLeavingTeam"
                                    v-if="$page.props.user.id === user.id && false">
                                    Leave
                                </button>

                                <!-- Remove Team Member -->
                                <button class="cursor-pointer ml-6 text-sm text-red-500"
                                    @click="confirmTeamMemberRemoval(user)" v-if="$page.props.user.id !== user.id && userPermissions.canRemoveTeamMembers
                                        && (user.membership.role == 'member' || $page.props.user.id == team.owner.id)">
                                    Remove
                                </button>
                            </div>
                        </div>



                        <div class="flex justify-around items-center pt-5">

                            <div class="flex items-center justify-start flex-grow text-gray-700">
                                Showing {{ (currentPage - 1) * teammates_per_page + 1 }} to {{ currentPage *
                                    teammates_per_page }} of {{ team_searched.length }} members
                            </div>

                            <div class="flex justify-end items-center">

                                <button type="button"
                                    :class="[currentPage == 1 ? 'opacity-60 cursor-default' : 'hover:bg-gray-50', 'relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300  focus:z-10']"
                                    @click="currentPage = 1" :disabled="currentPage == 1">First</button>
                                <button type="button"
                                    :class="[currentPage == 1 ? 'opacity-60 cursor-default' : 'hover:bg-gray-50', 'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:z-10']"
                                    @click="currentPage--" :disabled="currentPage == 1">Previous</button>
                                <button type="button"
                                    :class="[currentPage * teammates_per_page >= team_searched.length ? 'opacity-60 cursor-default' : 'hover:bg-gray-50', 'relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:z-10']"
                                    @click="currentPage++"
                                    :disabled="currentPage * teammates_per_page >= team_searched.length">Next</button>
                                <button type="button"
                                    :class="[currentPage * teammates_per_page >= team_searched.length ? 'opacity-60 cursor-default' : 'hover:bg-gray-50', 'relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300  focus:z-10']"
                                    @click="currentPage = Math.ceil(team_searched.length / teammates_per_page)"
                                    :disabled="currentPage * teammates_per_page >= team_searched.length">Last</button>
                            </div>
                        </div>


                    </div>
                </template>
            </jet-action-section>
        </div>

        <!-- Role Management Modal -->
        <jet-dialog-modal :show="currentlyManagingRole" @close="currentlyManagingRole = false">
            <template #title>
                Manage Role
            </template>

            <template #content>
                <div v-if="managingRoleFor">
                    <div class="relative z-0 mt-1 border border-gray-200 rounded-lg cursor-pointer">
                        <button type="button"
                            class="relative px-4 py-3 inline-flex w-full rounded-lg focus:z-10 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200"
                            :class="{ 'border-t border-gray-200 rounded-t-none': i > 0, 'rounded-b-none': i !== Object.keys(the_roles).length - 1 }"
                            @click="updateRoleForm.role = role.key" v-for="(role, i) in the_roles" :key="role.key">
                            <div :class="{ 'opacity-50': updateRoleForm.role && updateRoleForm.role !== role.key }">
                                <!-- Role Name -->
                                <div class="flex items-center">
                                    <div class="text-sm text-gray-600"
                                        :class="{ 'font-semibold': updateRoleForm.role === role.key }">
                                        {{ role.name }}
                                    </div>

                                    <svg v-if="updateRoleForm.role === role.key" class="ml-2 h-5 w-5 text-green-400"
                                        fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        stroke="currentColor" viewBox="0 0 24 24">
                                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                </div>

                                <!-- Role Description -->
                                <div class="mt-2 text-xs text-gray-600">
                                    {{ role.description }}
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </template>

            <template #footer>
                <jet-secondary-button @click="currentlyManagingRole = false">
                    Cancel
                </jet-secondary-button>

                <jet-button class="ml-2" @click="updateRole" :class="{ 'opacity-25': updateRoleForm.processing }"
                    :disabled="updateRoleForm.processing">
                    Save
                </jet-button>
            </template>
        </jet-dialog-modal>

        <!-- Leave Team Confirmation Modal -->
        <jet-confirmation-modal :show="confirmingLeavingTeam" @close="confirmingLeavingTeam = false">
            <template #title>
                Leave Team
            </template>

            <template #content>
                Are you sure you would like to leave this team?
            </template>

            <template #footer>
                <jet-secondary-button @click="confirmingLeavingTeam = false">
                    Cancel
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click="leaveTeam" :class="{ 'opacity-25': leaveTeamForm.processing }"
                    :disabled="leaveTeamForm.processing">
                    Leave
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>

        <!-- Remove Team Member Confirmation Modal -->
        <jet-confirmation-modal :show="teamMemberBeingRemoved" @close="teamMemberBeingRemoved = null">
            <template #title>
                Remove Team Member
            </template>

            <template #content>
                Are you sure you would like to remove this person from the team?
            </template>

            <template #footer>
                <jet-secondary-button @click="teamMemberBeingRemoved = null">
                    Cancel
                </jet-secondary-button>

                <jet-danger-button class="ml-2" @click="removeTeamMember"
                    :class="{ 'opacity-25': removeTeamMemberForm.processing }"
                    :disabled="removeTeamMemberForm.processing">
                    Remove
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
    </div>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetActionSection from '@/Jetstream/ActionSection'
import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetButton from '@/Jetstream/Button'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import Toggle from '@/Components/UI/Toggle'
import Spinner from '@/Components/UI/Spinner'
import { ClipboardIcon } from "@heroicons/vue/24/outline"
import { PlusIcon } from "@heroicons/vue/16/solid";
import ProfileImage from '@/Components/UI/ProfileImage'


import { router, useForm, usePage } from '@inertiajs/vue3'

export default {
    components: {
        JetActionMessage,
        JetActionSection,
        JetButton,
        JetConfirmationModal,
        JetDangerButton,
        JetDialogModal,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetSectionBorder,
        Toggle,
        Spinner,
        ClipboardIcon, PlusIcon, ProfileImage
    },

    props: [
        'team',
        'availableRoles',
        'userPermissions'
    ],

    data() {
        return {
            addTeamMemberForm: useForm({
                invites: [
                    {
                        email: '',
                        role: null,
                        error: null
                    }
                ],
            }),
            last_invite: null,

            live_teamInvitations: this.team.team_invitations,

            updateRoleForm: useForm({
                role: null,
            }),

            leaveTeamForm: useForm({}),
            removeTeamMemberForm: useForm({}),

            currentlyManagingRole: false,
            managingRoleFor: null,
            confirmingLeavingTeam: false,
            teamMemberBeingRemoved: null,
            team_filtered: [],
            team_hidden_emails: [],
            is_updating_seats: false,
            search: '',
            currentPage: 1,
            teammates_per_page: 10,
            can_invite_outside_sso: this.team?.can_invite_outside_sso ?? true,
            domains: [],
            the_roles: this.availableRoles,
            default_role_name: 'Member',
            default_role_key: 'member',
            last_role: '',
            team_invite_link: `https://${this.$page.props.user.current_team.slugname}.birdie.so/join-team/${this.$page.props.user.current_team.slug}`,
            sending_invites: false,
        }
    },
    created() {

        // Set default role and shorten labels where needed
        for (var i = 0; i < this.the_roles.length; i++) {
            if (this.the_roles[i].name == 'Administrator') {
                this.the_roles[i].name = 'Admin'
            }
        }
        this.initializeForm()
        //console.log(this.the_roles)

        if (this.team.team_domains) {
            this.domains = this.team.team_domains.split(',').map(domain => domain.trim())
        }
        if (this.team.users) {
            if (this.team.users.length > 0) {
                for (var i = 0; i < this.team.users.length; i++) {
                    const user = this.team.users[i]
                    if (user.email_verified_at && user.enabled) {
                        if (!user.active) {
                            this.team_hidden_emails.push(user.email.toLowerCase())
                        } else {
                            if (user.metadata != null) {
                                user.metadata = JSON.parse(user.metadata)
                            } else {
                                user.metadata = {}
                            }
                            this.team_filtered.push(user)
                        }
                    }
                }
            }
        }
    },
    mounted() {
        if (window.location.hash) {
            const hash = window.location.hash.substring(1)
            if (document.getElementById(hash)) {
                setTimeout(function () {
                    const top = document.getElementById(hash).offsetTop - 65;
                    window.scrollTo(0, top);
                }, 100)
            }
        }
    },
    methods: {
        initializeForm() {
            this.addTeamMemberForm.invites = [
                {
                    email: '',
                    role: this.default_role_key,
                    error: null
                }
            ]
            // for (var i = 0; i < this.the_roles.length; i++) {
            //     if (this.the_roles[i].name == this.default_role_name) {
            //         this.addTeamMemberForm.invites[0].role = this.the_roles[i].key
            //         this.default_role_key = this.the_roles[i].key
            //         this.last_role = this.the_roles[i].key
            //         break;
            //     }
            // }
        },
        addInvite() {
            const last_invite = this.addTeamMemberForm.invites[this.addTeamMemberForm.invites.length - 1]
            this.last_role = last_invite.role
            this.addTeamMemberForm.invites.push({
                email: '',
                role: last_invite.role,
                error: null
            })
        },
        copied: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Invite link copied in your clipboard!", options)
        },
        changeEmailValue(value, index) {
            this.addTeamMemberForm.invites[index].error = null
        },
        sendInvites() {

            // this.addTeamMemberForm.post(this.$page.props.api_url + '/v1/team/invite/exist', {
            //         errorBag: 'addTeamMember',
            //         preserveScroll: true,@
            //         onSuccess: () => this.addTeamMemberForm.reset(),
            //     });
            //     return

            // this.last_role = this.addTeamMemberForm.role
            // if (this.addTeamMemberForm.role == null) {
            //     this.addTeamMemberForm.role = 'member'
            // }

            // 1 - filter obvious non-valid emails
            let errors = 0
            for (var i = 0; i < this.addTeamMemberForm.invites.length; i++) {
                if (!this.validateEmail(this.addTeamMemberForm.invites[i].email) && this.validateNotempty(this.addTeamMemberForm.invites[i].email)) {
                    this.addTeamMemberForm.invites[i].error = 'This is not a valid email address.'
                    errors++
                } else {
                    this.addTeamMemberForm.invites[i].error = null
                }
            }
            if (errors > 0) {
                return
            }

            // 2 - filter out empty email invites
            this.addTeamMemberForm.invites = this.addTeamMemberForm.invites.filter(invite => this.validateNotempty(invite.email));
            if (this.addTeamMemberForm.invites.length == 0) {
                this.initializeForm()
                let options = {
                    type: "warning",
                    timeout: 10000,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast("No invitation was sent, no emails provided", options)
                return
            }

            // 3 - filter out duplicate emails and trim + lowercase emails
            let invites = []
            for (var i = 0; i < this.addTeamMemberForm.invites.length; i++) {
                const email = this.addTeamMemberForm.invites[i].email.trim().toLowerCase()
                let canAdd = true
                for (var j = 0; j < invites.length; j++) {
                    if (invites[j].email == email) {
                        canAdd = false
                        continue
                    }
                }
                if (canAdd) {
                    const invite = this.addTeamMemberForm.invites[i]
                    invite.email = email
                    invites.push(invite)
                }
            }

            // 4 - add a mark if email is already in the hidden emails list
            for (var i = 0; i < invites.length; i++) {
                if (this.team_hidden_emails.includes(invites[i].email.toLowerCase())) {
                    invites[i].hidden_user = invites[i].email
                }
            }


            // if (this.team_hidden_emails.includes(this.addTeamMemberForm.email.toLowerCase())) {
            //     this.addTeamMemberForm.post(this.$page.props.api_url + '/v1/team/invite/exist', {
            //         errorBag: 'addTeamMember',
            //         preserveScroll: true,
            //         onSuccess: () => {
            //             this.addTeamMemberForm.reset()
            //             this.addTeamMemberForm.role = this.last_role
            //         }
            //     });
            //     return
            // }

            // this.addTeamMemberForm.post(this.$page.props.api_url + '/v1/team/invite/batch', {
            //     errorBag: 'addTeamMember',
            //     preserveScroll: true,
            //     onError: (error) => {
            //         console.log("error", error)
            //     },
            //     onSuccess: (result) => {
            //         console.log("success", result)
            //         // this.addTeamMemberForm.reset()
            //         // this.addTeamMemberForm.role = this.last_role
            //     }
            // });
            let url = this.$page.props.api_url + '/v1/team/invite/batch';
            var params = {
                invites: invites
            };
            axios.post(url, params)
                .then(response => {
                    // console.log(response.data)
                    const remaining_invites = []
                    if (response.data.invites.length > 0) {
                        for (var i = 0; i < response.data.invites.length; i++) {
                            const invite = response.data.invites[i]
                            if (invite.error) {
                                remaining_invites.push(invite)
                            }
                        }
                    }
                    let notificationType = "success"
                    let notificationMessage = "Invitations sent successfully"
                    if (remaining_invites.length > 0) {
                        notificationType = this.addTeamMemberForm.invites.length != remaining_invites.length ? "warning" : "danger"
                        notificationMessage = this.addTeamMemberForm.invites.length != remaining_invites.length ? "Some invitations were not sent" : "No invitation was sent"
                        this.addTeamMemberForm.invites = remaining_invites

                    } else {
                        this.initializeForm()
                    }
                    let options = {
                        type: notificationType,
                        timeout: 6000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.live_teamInvitations = response.data.teamInvitations
                    this.$moshaToast(notificationMessage, options)
                    this.sending_invites = false
                })
                .catch(e => {
                    console.error(e);
                    let options = {
                        type: "danger",
                        timeout: -1,
                        position: "top-right",
                    }
                    this.$moshaToast("An error occurred while sending invitations", options)
                    this.sending_invites = false
                });

            // this.addTeamMemberForm.post(route('team-members.store', this.team), {
            //     errorBag: 'addTeamMember',
            //     preserveScroll: true,
            //     onSuccess: () => {
            //         this.addTeamMemberForm.reset()
            //         this.addTeamMemberForm.role = this.last_role
            //     }
            // });
        },


        // toggleCobrowsingSeat(user) {
        //     if (this.is_updating_seats) {
        //         return
        //     }

        //     //var the_user = JSON.parse(JSON.stringify(this.team_filtered[user_index]));

        //     const turn_to = !user.metadata.cobrowsing_seat

        //     if (turn_to && !this.can_add_cobrowsing_seat) {
        //         let options = {
        //             type: "info",
        //             timeout: -1,
        //             position: "top-right",
        //             toastBackgroundColor: '#207FFF',
        //             //hideProgressBar: false,
        //         }
        //         this.$moshaToast({
        //             title: "Upgrade your subscription to enable more seats.",
        //             description: `<a href='${route('subscription.index')}' title='Upgrade'>Go to your subscription settings →</a>`
        //         }, options)
        //         return
        //     }

        //     this.is_updating_seats = true
        //     user.is_updating_seats = true
        //     let url = this.$page.props.api_url + '/v1/user/set_meta/' + user.id;


        //     var params = {
        //         meta: "cobrowsing_seat",
        //         value: turn_to
        //     };
        //     axios.post(url, params)
        //         .then(response => {
        //             //if (response.data) {
        //             user.metadata.cobrowsing_seat = turn_to
        //             //}
        //             this.is_updating_seats = false
        //             user.is_updating_seats = false
        //         })
        //         .catch(e => {
        //             console.error(e);
        //             this.is_updating_seats = false
        //             user.is_updating_seats = false
        //         });
        // },


        cancelTeamInvitation(invitation) {
            router.delete(route('team-invitations.destroy', invitation), {
                preserveScroll: true,
                onSuccess: () => {
                    this.live_teamInvitations = this.live_teamInvitations.filter(i => i.id !== invitation.id);
                    let options = {
                        type: "success",
                        timeout: 6000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Invitation cancelled successfully", options);
                },
                onError: (errors) => {
                    // Show error toast
                    let options = {
                        type: "danger",
                        timeout: 6000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Failed to cancel invitation", options);
                    console.error(errors);
                }
            });
        },

        resendTeamInvitation(invitation) {
            let url = route('team-invitations.resend', invitation)
            console.log(url)
            var params = {};
            axios.post(url, params)
                .then(response => {
                    console.log(response)
                    for (var i = 0; i < this.team.team_invitations.length; i++) {
                        if (this.live_teamInvitations[i].id == invitation.id) {
                            this.live_teamInvitations[i].resent = true
                            break
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                });


            // router.post(route('team-invitations.resend', invitation), {
            //     preserveScroll: true,
            //     preserveState: true,
            //     onSuccess: () => {
            //         for (var i = 0; i < this.team_invitations.length; i++) {
            //             if (this.team_invitations[i].id == invitation.id) {
            //                 this.team_invitations[i].resent = true
            //                 break
            //             }
            //         }
            //     }
            // });
        },

        manageRole(teamMember) {
            this.managingRoleFor = teamMember
            this.updateRoleForm.role = teamMember.membership.role
            this.currentlyManagingRole = true
        },

        updateRole() {
            this.updateRoleForm.put(route('team-members.update', [this.team, this.managingRoleFor]), {
                preserveScroll: true,
                onSuccess: () => (this.currentlyManagingRole = false),
            })
        },

        confirmLeavingTeam() {
            this.confirmingLeavingTeam = true
        },

        leaveTeam() {
            this.leaveTeamForm.delete(route('team-members.destroy', [this.team, usePage.props.user]))
        },

        confirmTeamMemberRemoval(teamMember) {
            this.teamMemberBeingRemoved = teamMember
        },

        refreshListWithoutRemoved() {
            for (var i = 0; i < this.team_filtered.length; i++) {
                if (this.teamMemberBeingRemoved.id == this.team_filtered[i].id) {
                    this.team_filtered.splice(i, 1)
                    break
                }
            }
            this.teamMemberBeingRemoved = null
        },

        removeTeamMember() {
            this.removeTeamMemberForm.delete(route('team-members.destroy', [this.team, this.teamMemberBeingRemoved]), {
                errorBag: 'removeTeamMember',
                preserveScroll: true,
                preserveState: true,
                onSuccess: () => {
                    this.refreshListWithoutRemoved()
                },
            })
        },

        displayableRole(role) {
            return this.availableRoles.find(r => r.key === role).name
        },

        validateEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        validateNotempty: function (value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        },

    },
    computed: {
        role_description() {
            const role = this.the_roles.find(r => r.key === this.addTeamMemberForm.role)
            return role ? role.description : ''
        },
        // can_add_cobrowsing_seat() {
        //     let max_seats = this.$page.props.cobrowsing_seats
        //     if (max_seats < 0) {
        //         return true
        //     }
        //     var count_seats = 0
        //     for (var i = 0; i < this.team_filtered.length; i++) {
        //         if (this.team_filtered[i].metadata) {
        //             if (this.team_filtered[i].metadata.cobrowsing_seat) {
        //                 count_seats++
        //             }
        //         }
        //     }
        //     return count_seats < max_seats
        // },
        team_searched() {
            if (this.search == '') {
                return this.team_filtered
            }
            return this.team_filtered.filter(user => {
                return user.name.toLowerCase().includes(this.search.toLowerCase()) || user.email.toLowerCase().includes(this.search.toLowerCase())
            })
        },
        team_paginated() {
            if (this.team_filtered.length <= this.teammates_per_page) {
                return this.team_filtered
            }
            return this.team_searched.slice((this.currentPage - 1) * this.teammates_per_page, this.currentPage * this.teammates_per_page)
        }
    },
    watch: {
        search() {
            // console.log('reset to p1 due to filter');
            this.currentPage = 1;
        }
    },
}
</script>
